module.exports = __webpack_public_path__ + "img/detail_banner_ybywzhfw.1811b532.png";